import Service from "../../Services/index";

const pdf = {
    namespaced: true,
    state: {
        InvoiceList: [],
    },
    mutations: {},
    actions: {
        showInvoicePDF({commit}, id) {
            return Service.PDF.getInvoicePDF(id).then(() => {
                //console.log("download invoice success");
            })
        },
        showOrderPDF({commit}, id) {
            return Service.PDF.getOrderPDF(id).then(() => {
                //console.log("download order success");
            })
        },
    }
};

export default pdf;
